const generatePostHeaders = (contentType) => {
  // let headers = { Accept: 'application/json' }
  let headers = {}
  headers['Content-Type'] = contentType || 'application/json'
  return headers
}
const generateQueryParams = function (params) {
  let r = []
  if (params) {
    for (let p in params) {
      let v = params[p]
      if (v !== null && v !== undefined) {
        if (Array.isArray(v)) {
          r.push(p + '=' + v.join(','))
        } else {
          r.push(p + '=' + encodeURIComponent(v))
        }
      }
    }
    if (r.length > 0) {
      return '?' + r.join('&')
    }
  }
  return ''
}
const generatePostData = function (params) {
  let r = []
  if (params) {
    for (let p in params) {
      let v = params[p]
      if (v) {
        if (Array.isArray(v)) {
          r.push(p + '=' + v.join(','))
        } else {
          r.push(p + '=' + encodeURIComponent(v))
        }
      }
    }
    if (r.length > 0) {
      return r.join('&')
    }
  }
  return ''
}
export default {
  generatePostHeaders,
  generateQueryParams,
  generatePostData
}
